import React, { useState } from "react"
import { WingsModal } from "@wingspans-ui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ResumeExperienceEditorModal from "./ResumeExperienceEditorModal"
import ResumeTipsModal from "./tips/tips-modal"
import { FormattedMessage } from "react-intl"
import { experienceTypeData } from "./utils/experienceTypes"

/**
 * Modal for adding a new resume experience of any type. Contains three modals
 * in total:
 * 1) A modal for selecting which type of experience to add
 * 2) A ResumeTipsModal
 * 3) A ResumeExperienceEditorModal for actually adding the new resume experience
 */
const ExperienceTypeSelector = ({ isSelectorModalOpen, closeSelectorModal }) => {
  const [selectedType, setSelectedType] = useState(null)
  const [tipsModalOpen, setTipsModalOpen] = useState(false)

  const handleClose = () => {
    setSelectedType(null)
    closeSelectorModal()
  }

  return (
    <>
      {/* first modal, for selecting */}
      <WingsModal
        className="selector-modal"
        isOpen={isSelectorModalOpen && (selectedType === null) && !tipsModalOpen}
        onClose={handleClose}
        size="md"
        title={<FormattedMessage id="portfolio-experience-selector-add-experience" defaultMessage="Add experience" />}
        titleLevel={5}
        secondaryActionLabel={<FormattedMessage id="portfolio-experience-selector-resume-tips" defaultMessage="Resume Tips"/>}
        onSecondaryAction={() => setTipsModalOpen(true)}
      >
        <WingsModal.Body>
          {experienceTypeData.map(section => (
            <button
              key={section.type}
              className="experience-type-row"
              onClick={() => setSelectedType(section.type)}
            >
              <span className="experience-type-row-icon">
                <FontAwesomeIcon icon={section.icon} />
              </span>
              <span className="experience-type-row-label">
                {section.label}
              </span>
            </button>
          ))}
        </WingsModal.Body>
      </WingsModal>

      {/* second modal, for adding a new experience */}

      <ResumeTipsModal 
        show={tipsModalOpen}
        onClose={() => setTipsModalOpen(false)}
      />

      <ResumeExperienceEditorModal
        isNewExperience={true}
        show={selectedType !== null}
        type={selectedType}
        closeTimelineModal={() => handleClose()}
      />
    </>
  )
}

export default ExperienceTypeSelector
